<app-nav></app-nav>
<div class="container" innerHTML="{{ 'imprint' | translate }}"></div>
<app-footer></app-footer>
